import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { WeekdaySearches } from '@/features/admin/weekday-searches'

const searchSchema = z.object({
  page: z.number().optional(),
  listPage: z.number().optional().catch(1),
  listPageSize: z.number().optional().catch(20),
  filter: z.string().optional().catch(''),
})

export const Route = createFileRoute(
  '/_authenticated/admin/weekday-searches/$searchId'
)({
  component: WeekdaySearchesWithId,
  validateSearch: searchSchema,
})

function WeekdaySearchesWithId() {
  const { searchId } = Route.useParams()
  const { page, listPage, listPageSize, filter } = Route.useSearch()
  return (
    <WeekdaySearches
      searchId={searchId}
      page={page}
      listPage={listPage}
      listPageSize={listPageSize}
      filter={filter}
    />
  )
}
